<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                                           :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                                           :query-api="isManager ? undefined : 'query/customer'"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesRitaTestTaskResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      with-custom-row-actions-first-column
                                      :edit-disable="!isManager"
                                      :detailInlineButtonDisable="!isManager"
                                      custom-row-actions-text-first-column="操作"
                                      :$_em-custom-vuex-mixin_vo="customVuexName + 'Vo'"
                                      :$_em-custom-vuex-mixin_filter="customVuexName + 'Filter'"
                                      :query-api="isManager ? undefined : 'query/customer'"
                                      ref="emTable" exportDisabled :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #customRowActionsFirstColumn="{row}">
                                    <b-button-group>
                                        <em-button
                                            type="search"
                                            v-if="isManager"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="选择参与客户"
                                            custom-icon="fa fa-th-list"
                                            :busy="userRelateLoading"
                                            :disabled="gettingRitaDeptId"
                                            @click="openModal(row)"
                                        ></em-button>
                                        <em-button
                                            type="qualified"
                                            v-if="isManager"
                                            class="btn btn-outline-primary btn-sm"
                                            customLabel="试验通过"
                                            confirm-text="是否确认验收该任务"
                                            :busy="taskPassLoading"
                                            @click="passTask(row)"
                                        ></em-button>
                                        <em-button
                                            type="uploadFile"
                                            class="btn btn-outline-primary btn-sm"
                                            custom-label="上传附件"
                                            :busy="saveAttachmentLoading"
                                            @click="openUploadAttachment(row)">
                                        </em-button>
                                        <em-button
                                            type="gotoExecute"
                                            class="btn btn-outline-primary btn-sm"
                                            custom-label="打开摄像头画面"
                                            @click="$router.push('/ritaPage?taskId=' + row.id)"
                                        ></em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>

        <ReBModal ref="userRelated" header="选择参与客户" @ok="handleUserSelect">
            <em-dept-user-tree ref="deptUserTree" :dept-id="ritaDeptId"></em-dept-user-tree>
        </ReBModal>

        <ReBModal header="上传附件"
                  @ok="saveAttachment"
                  :loading="loadingAttachment"
                  ref="uploadAttachment">
            <em-attachment class="w-100"
                           ref="emAttachment"
                           is-editing
                           :avoid-null="false"
                           :delete-enable="isManager"
                           :check-enable="isManager"
                           get-items-by-self
                           :attachment-ids="attachmentIds"
                           :checked-attachment-ids="openAttachmentIds"
                           @loading="loadingChange"
                           @checkChanged="changeCheck"
                           @idsChanged="changeAttachmentIds">
            </em-attachment>
        </ReBModal>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2021-08-02 17:31:47

import emCommonListMixin from "@/mixin/em/common/list";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal";
import EmDeptUserTree from "@/components/em/EmBusiness/deptUserTree";
import EmAttachment from "@/components/em/EmAttachment";

export default {
    name: "sithMesRitaTestTaskListView",
    components: {EmAttachment, EmDeptUserTree, ReBModal},
    mixins: [emCommonListMixin],
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        },
        customVuexName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            taskSelect: null,
            attachmentIds: "",
            openAttachmentIds: "",

            ritaDeptId: '',
            //loading
            loadingAttachment: false,
            userRelateLoading: false,
            taskPassLoading: false,
            saveAttachmentLoading: false,
            gettingRitaDeptId: true,
        }
    },
    computed: {
        modelName() {
            return 'sithMesRitaTestTask'
        },
        isManager() {
            return this.customVuexName === 'manager';
        }
    },
    watch: {
        customVuexName() {
            this.$nextTick(() => {
                this.$refs.emListFilter.doQuery();
                this.$refs.viewTitle.getMenuTitleData();
            })
        }
    },
    mounted() {
        this.getRitaDeptId();
    },
    methods: {
        openModal(row) {
            this.taskSelect = row;
            this.$refs.userRelated.showModal();
        },
        handleUserSelect() {
            this.userRelateLoading = true;
            let userIds = this.$refs.deptUserTree.getUserIds();
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_RITA_URL + "/sithMesRitaTestTask/selective",
                entity: {
                    id: this.taskSelect.id,
                    userRelated: userIds
                }
            }).then(() => {
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.userRelateLoading = false);
        },
        passTask(row) {
            this.taskPassLoading = true;
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_RITA_URL + "/sithMesRitaTestTask/finishTask?taskId=" + row.id,
            }).then(() => {
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.taskPassLoading = false);
        },
        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        changeCheck(ids) {
            this.openAttachmentIds = ids;
        },
        openUploadAttachment(row) {
            this.attachmentIds = this.isManager ? row.attachments : row.attachmentCustom;
            this.openAttachmentIds = row.attachmentOpen;
            this.taskSelect = row;
            this.$refs.uploadAttachment.showModal();
        },
        saveAttachment() {
            this.saveAttachmentLoading = true;
            let entity = {
                id: this.taskSelect.id
            }
            if (this.isManager) {
                entity.attachments = this.attachmentIds;
                entity.attachmentOpen = this.openAttachmentIds;
            } else {
                entity.attachmentCustom = this.attachmentIds;
            }
            this.$store.dispatch('api/put', {
                url: process.env.VUE_APP_SITHMES_RITA_URL + "/sithMesRitaTestTask/selective",
                entity: entity
            }).then(() => {
                this.$message.success("操作成功");
                this.$refs.emListFilter.doQuery();
            }).finally(() => this.saveAttachmentLoading = false);
        },
        loadingChange(val) {
            this.loadingAttachment = val;
        },
        getRitaDeptId() {
            this.$store.dispatch('api/post', {
                url: process.env.VUE_APP_SITHMES_MST_URL + "/sithMesMstLocation/findByFilter",
                data: {
                    codeFilter: "Rita"
                }
            }).then(response => {
                if (response.data.list.length > 0) {
                    this.ritaDeptId = response.data.list[0].id;
                    this.gettingRitaDeptId = false;
                }else {
                    this.$message.error("未找到部门：Rita客户");
                }
            })
        }
    }
};
</script>